module.exports = __webpack_public_path__ + "static/media/scene.f7fbad00.gltf";